<template>
    <div class="UserInput" :id="parentElementID">
        <input :id="elementID" :v-model="userInput" @input="emitInput"/>
    </div>
</template>

<script>
export default{
    props:{
        parentElementID: String,
        elementID: String
    },
    data(){
        return{
            userInput: ''
        };
    },
    methods:{
        emitInput(event){
            this.userInput = event.target.value;
            this.$emit('input', this.userInput);
            this.$emit('input-change', this.userInput);
        }
    },
};
</script>

<style>
.UserInput input
{
    border-radius: 5px;
}

.UserInput span
{
    font-weight: bold;
}
</style>